module.exports = __webpack_public_path__ + "components/flag/static/square/mt-9bf079d3d3399cf1a7d5142b1fb1bafc.svg";